import { MediumSectionContent } from '@ui-components/containers/MediumSectionContent'
import { TertiaryHeading } from '@ui-components/typography/headings/TertiaryHeading'
import { BodyText } from '@ui-components/typography/Typography'
import { JSX, ReactNode } from 'react'
import { useIntl } from 'react-intl'

export const EntranceDataProtection = ({
  children,
  shouldShowHeader = true,
}: {
  children: ReactNode
  shouldShowHeader?: boolean
}): JSX.Element => {
  const { formatMessage } = useIntl()
  return (
    <MediumSectionContent>
      {shouldShowHeader && (
        <TertiaryHeading header={formatMessage({ id: 'common-entrance-data-protection-header' })} tagName="h2" />
      )}
      <BodyText>{children}</BodyText>
    </MediumSectionContent>
  )
}
